import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Router, RoutesRecognized } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../../header.service';
import { ProfileService } from '../../profile.service';
import * as Globals from '../../globals';
import { BLAST_EMAIL } from 'app/models/blastemail';
const url = Globals.serviceUrl;
declare var $: any;

@Component({
  selector: 'app-email-detail',
  templateUrl: './email-detail.component.html',
  styleUrls: ['./email-detail.component.css']
})
export class EmailDetailComponent implements OnInit {
  invForm: FormGroup;
  packageArray: FormArray;
  @Input() userProfile: any;
  @Input() authMenu: any;
  @Input() beId: number;
  be: any;
  loading: boolean;
  userId: number;
  tab: number = 2;
  beResult: any;
  timeSch: string;
  timeschOpt: any;
  blastEmail: BLAST_EMAIL;
  SUBJECT: string;
  MESSAGE: string;
  TIMESCH: Date;
  ATTACHMENTS: string;
  STATUS: string;
  CC: string;
  BCC: string;
  changeFilterBy: string = '';
  isFileChosen: boolean = false;
  fileName: string = '';
  @Output() refreshParent = new EventEmitter;
  @ViewChild("fileInput") fileInput: any;
  @ViewChild("attachments") attachment: any;
  selectedFile: File;
  fileList: File[] = [];
  listOfFiles: any[];
  FILTER: any;
  Operator: any[] = [
    { id: 1, opr: '=' },
    { id: 2, opr: '<>' },
    { id: 3, opr: '>' },
    { id: 4, opr: '>=' },
    { id: 5, opr: '<' },
    { id: 6, opr: '<=' }
  ];
  Desc: any[];

  constructor(private fb: FormBuilder, private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private router: Router, private profileService: ProfileService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.userProfile = { PARENT_GROUP_ID: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/email/1') {
          this.tab = 2;
          this.router.navigate(['/email/2']);
        }
      };
    });
    this.createForm();
  }

  createForm() {
    //console.log(this.be.Filter);
    this.invForm = this.fb.group({
      operator1: ['and', Validators.required],
      filterInv: this.packageArray
      //console.log(filterInv);
    })
  }

  ngOnInit() {
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.authMenu = Globals.getAuthMenu(800, this.userProfile);
    }
    if (this.beId > 0) {
      this.getBe(this.beId);
    }
    else {
      this.newBlast();
      this.invForm = this.fb.group({
        operator1: ['and', Validators.required],
        filterInv: new FormArray([])
        //console.log(filterInv);
      });
    }
    //console.log(this.FILTER);
    //console.log(dataFilter);
    // this.invForm = new FormGroup({
    //   operator1: new FormControl(''),
    //   filterInv: new FormArray([
    //     this.initFilterBy(),
    //   ]),
    // });
  }

  getForm(dataFilter: any) {
    let test = JSON.parse(dataFilter);
    if (this.FILTER) {
      this.invForm = this.FILTER;
      console.log(test.filterInv);
      console.log(this.invForm);
    }
    console.log(this.FILTER);
    //console.log(this.invForm);
    //console.log(this.invForm.controls.filterInv);
    if (test == null) {
      this.invForm = this.fb.group({
        operator1: ['and', Validators.required],
        filterInv: new FormArray([])
        //console.log(filterInv);
      });
    }
    else {
      this.invForm = new FormGroup({
        operator1: new FormControl(test.operator1),
        filterInv: new FormArray(
          test.filterInv.map(item => {
            const group = this.initFilterBy();
            group.patchValue(item);
            return group;
          }))
      });
    }

  }

  initFilterBy() {
    return new FormGroup({
      filterBy: new FormControl('', Validators.required),
      operator2: new FormControl('', Validators.required),
      desc: new FormControl('', Validators.required)
    });
  }

  initItemRows() {
    return this.fb.group({
      itemname: ['']
    });
  }

  public addPackageRow(): void {
    const control = (<FormArray>this.invForm.get('filterInv'));
    control.push(this.initFilterBy());
  }

  addFilter() {
    const control = (<FormArray>this.invForm.get('filterInv'));
    control.push(this.initFilterBy());
  }

  onFormSubmit() {
    let data = this.invForm.value;
    this.FILTER = JSON.stringify(this.invForm.value);
    $('#modal').modal('hide');

  }

  getfilterInv(invForm) {
    return invForm.controls.filterInv.controls;
  }

  public removeFilter(i) {
    const control = <FormArray>this.invForm.get('filterInv');
    control.removeAt(i);
  }

  resetFilter() {
    const control = <FormArray>this.invForm.get('filterInv');
    while (0 !== control.length) {
      control.removeAt(0);
    }
    this.invForm.reset({
      operator1: ['and'],
      filterInv: new FormArray([])
    });
  }

  newBlast() {
    this.be = new BLAST_EMAIL(0, null, null, new (Date), new (Date), 0, 0, null, this.userProfile.USER_ID, new (Date), this.userProfile.USER_ID, new (Date), 0, new (Date), null, null, null);
    //this.createForm();
  }

  loadParent() {
    this.refreshParent.emit();
  }

  onFilterChanged(event: any) {
    this.changeFilterBy = event.target.value;
    if (this.changeFilterBy == "lokasi") {
      this.Operator = [{ id: 1, opr: '' },{ id: 2, opr: '=' }];
      // for (let index = 0; index < this.Operator.length; index++) {
      //   const control = (<FormArray>this.invForm.get('filterInv'));
      //   control.push(this.Operator.find(i=>i.opr));
      // }
      // console.log(this.invForm);
    }
    else if(this.changeFilterBy == "gender") {
      this.Operator = [{ id: 1, opr: '' },{ id: 2, opr: '=' }];
      this.Desc = [
        { id: 1, desc: 'Laki - laki' },
        { id: 2, desc: 'Perempuan' }
      ];
    }
    else if(this.changeFilterBy == "tipeinvestor") {
      this.Operator = [{ id: 1, opr: '' },{ id: 2, opr: '=' }];
      this.Desc = [
        { id: 1, desc: 'Investor' },
        { id: 2, desc: 'Calon Investor' }
      ];
    }
    else if(this.changeFilterBy == "seri") {
      this.Operator = [{ id: 1, opr: '' },{ id: 2, opr: '=' }];
    }
    else if (this.changeFilterBy == "pekerjaan"){
      this.Operator = [{ id: 1, opr: '' },{ id: 2, opr: '=' }];
      this.Desc = [
        { id: 1, desc: 'PNS' },
        { id: 2, desc: 'TNI/Polri' },
        { id: 3, desc: 'Pegawai Otoritas/Lembaga/BUMN/BUMD' },
        { id: 4, desc: 'Pegawai Swasta' },
        { id: 5, desc: 'Profesional' },
        { id: 6, desc: 'Wiraswasta' },
        { id: 7, desc: 'Pekerja Seni' },
        { id: 8, desc: 'Pelajar/Mahasiswa' },
        { id: 9, desc: 'Ibu Rumah Tangga' },
        { id: 10, desc: 'Pensiunan' },
        { id: 11, desc: 'Lainnya' }
      ];
    }
    else{
      this.Operator = [
        { id: 1, opr: '=' },
        { id: 2, opr: '<>' },
        { id: 3, opr: '>' },
        { id: 4, opr: '>=' },
        { id: 5, opr: '<' },
        { id: 6, opr: '<=' }
      ];
    }
    
  }

  getBe(id) {
    this.loading = true;
    this.http.get(url + 'ritel/blastemail?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.beResult = res.json();
        this.be = this.beResult.Model;
        //this.timeSch = new DatePipe(this.timeSch).transform(this.be.TimeSch, 'MM/dd/yyyy HH:mm');
        //this.be.TimeSch = new Date(this.timeSch);
        //this.timeSch = new Date(this.be.TimeSch).toLocaleString();
        //console.log(this.be);
        this.be.TimeSch = this.timeSch;
        this.SUBJECT = this.be.Subject;
        this.MESSAGE = this.be.Message;
        this.TIMESCH = new Date(this.be.STimeSch);
        this.ATTACHMENTS = this.be.Attachment;
        this.STATUS = this.be.CdStatus;
        this.FILTER = this.be.Filter;
        //console.log(this.STATUS);
        this.listOfFiles = this.ATTACHMENTS.split(';');
        //console.log(this.ATTACHMENTS);
        this.CC = this.be.Cc;
        this.BCC = this.be.Bcc;
        this.getForm(this.FILTER);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  Save() {
    this.loading = true;
    //let data = JSON.parse(JSON.stringify(this.FILTER || null ));
    // if (data == undefined) {
    //   this.toastr.error('Klasifikasi Investor harus di isi.');
    // }
    // else{
    // let filter = JSON.parse(data);
    // console.log(filter);
    // if (filter.filterInv == null) {
    //     this.toastr.error('Detil Klasifikasi Investor harus di isi.');
    // }
    // else{

    // }
    console.log(this.fileList.length);
    console.log(this.listOfFiles);
    if (this.listOfFiles == undefined || this.fileList.length == 0) {
      this.toastr.error('File Upload harus di isi.');
    }
    else {
    let fi = this.fileList;
    this.be.SUBJECT = this.SUBJECT;
    this.be.MESSAGE = this.MESSAGE;
    this.timeSch = Globals.formatDateTime(this.TIMESCH);
    this.be.TIMESCH = this.timeSch;
    this.be.CC = this.CC;
    this.be.BCC = this.BCC;
    this.be.FILTER = this.FILTER;
    this.be.ATTACHMENT = this.ATTACHMENTS;
    // console.log(this.fileList);
    // console.log(this.listOfFiles);
    //alert(this.fileList.length);
    if (this.fileList.length > 0) {
      if (this.beId == 0) {
        this.http.post(Globals.serviceUrl + 'ritel/blastemail', this.be, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.beResult = res.json();
            //console.log(this.beResult);
            //console.log(res.json().Result.Model);
            this.uploadFile(res.json().Result.Model.BeId, fi);
            $('#modal').modal('hide');
            //this.toastr.success('Data berhasil disimpan');
            //this.getUsers();
            //this.loading = false;
          }, err => {
            console.log(err);
            if (err.status == 400) {
              this.toastr.error(err.json().Message);
            } else {
              this.toastr.error(Globals.errorMessage(err));
            }
            this.loading = false;
          });
      } else {
        this.http.put(Globals.serviceUrl + 'ritel/blastemail', this.be, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.uploadFile(res.json().Result.Model.BeId, fi);
            $('#modal').modal('hide');
            //this.toastr.success('Data berhasil disimpan');
            //this.getUsers();
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
    } else if (this.listOfFiles.length > 0) {
      //console.log("Berhasil Masuk");
      if (this.beId == 0) {
        this.http.post(Globals.serviceUrl + 'ritel/blastemail', this.be, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.beResult = res.json();
            this.loading = false;
          }, err => {
            console.log(err);
            if (err.status == 400) {
              this.toastr.error(err.json().Message);
            } else {
              this.toastr.error(Globals.errorMessage(err));
            }
            this.loading = false;
          });
      } else {
        this.http.put(Globals.serviceUrl + 'ritel/blastemail', this.be, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            $('#modal').modal('hide');
            this.toastr.success('Data berhasil disimpan');
            this.loadParent();
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
    }
    else {
      this.toastr.error('File Upload harus di isi.');
    }
    }

  }

  Confirm() {
    this.loading = true;
    //this.user.SD_EXPIRY = Globals.formatDate(this.user.D_EXPIRY);
    //this.be.CREATED_BY = this.userProfile.USER_ID;
    //this.be.UPD_BY = this.userProfile.USER_ID;
    this.be.CdStatus = '2';
    this.timeSch = Globals.formatDateTime(this.TIMESCH);
    this.be.TIMESCH = this.timeSch;
    //this.be.ConfirmBy = this.userProfile.USER_ID;
    //console.log(this.be);
    this.http.put(Globals.serviceUrl + 'ritel/blastemail', this.be, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil disimpan');
        this.loadParent();
        //this.getUsers();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  Delete() {
    //alert(this.tab);
    this.http.delete(Globals.serviceUrl + 'ritel/blastemail?id=' + this.beId, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.loadParent();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
    //this.loading = false;
  }

  onFileChange(event) {
    this.fileInput = event;
    //console.log(event);
  }

  onChanged(event: any) {
    this.listOfFiles = [];
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      var selectedFile = event.target.files[i];
      this.fileList.push(selectedFile);
      this.listOfFiles.push(selectedFile.name);
    }

    this.attachment.nativeElement.value = '';
  }

  removeSelectedFile(index) {
    // Delete the item from fileNames list
    this.listOfFiles.splice(index, 1);
    //console.log(index);
    // delete file from FileList
    this.fileList.splice(index, 1);
  }

  // addFilter() {
  //   this.inputFilter.push({INV_BY, OPERATOR, VALUE});
  // }

  uploadFile(id: number, fi: any) {
    //console.log(fi.length);
    if (fi.length > 0) {
      let fileToUpload = fi;
      let input = new FormData();
      for (var i = 0; i < fi.length; i++) {
        input.append("file", fileToUpload[i]);
      }
      let headers = new Headers({ 'Content-Type': 'multipart/form-data' });
      this.http.put(Globals.archiveUrl + "blastemail?id=" + id, input)
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil disimpan');
          this.getBe(id);
          this.loadParent();
          //this.loading = false;
        }, err => {
          console.log(err);
          if (err.status == 400) {
            this.toastr.error('File harus berformat pdf, tif, tiff.');
          }
          else if (err.status == 406) {
            this.toastr.error('File pdf maksimal berukuran 50MB.');
          }
          else {
            this.toastr.error(Globals.errorMessage(err));
            //this.toastr.error('Upload gagal. Silahkan dicoba lagi.');
          }
        });

    } else {
      this.toastr.error('File Upload harus di isi.');
      //this.loadParent();
      //this.getIssueInvestor();
    }
    this.loading = false;
  }

  timeschChanged(event: any) {
    /*this.dCloseOpt = { startDate: this.auction.OPEN_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
    this.timeschOpt = { format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };
  }

}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/email/email-detail/email-detail.component.ts